import CityPageTemplate from "../city-template/CityPageTemplate";
import { milfordDeConfig } from "./data";

export default function MilfordDePage() {
  return <CityPageTemplate config={milfordDeConfig} />;
}